import { cn } from "@/lib/utils";

export function SectionLabel({ children, className, align = "left" }) {
    return (
        <div className={cn("inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-muted-foreground", align === "center" && "justify-center", className)}>
            <span className="h-px w-6 bg-muted-foreground/40" />
            <span className="font-mono">{children}</span>
            <span className="h-px w-6 bg-muted-foreground/40" />
        </div>
    );
}

export function PillBadge({ children, tone = "default", className, ...rest }) {
    const tones = {
        default: "bg-secondary text-foreground border-border",
        accent: "bg-accent/15 text-accent-foreground border-accent/40",
        success: "bg-success/12 text-success border-success/30",
        warning: "bg-warning/12 text-warning-foreground border-warning/30",
        terracotta: "bg-terracotta/12 text-terracotta border-terracotta/30",
    };
    return (
        <span className={cn("inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-medium", tones[tone], className)} {...rest}>
            {children}
        </span>
    );
}

export function Divider({ className }) {
    return <div className={cn("h-px w-full bg-border", className)} />;
}
